<template>
  <div>
    <Header :showValue="3"></Header>
    <div class="jqgk" style="background: rgba(227, 227, 227, 0.84)">
      <div class="contai" style="max-width: 1197px">
        <div class="top_tit" style="margin-top: 20px">
          <!-- PC端文化类型 -->
          <div style="text-align: left" >
            <div class="culturetab">
              <div class="table-item" v-for="item in listCaiDan" :key="item.id">
                <div
                  :style="chooseValue == item.id ? styletable : mapStyle"
                  class="table-button"
                  @click="chooseTab(item)"
                >
                  <div class="cultureType_1">
                    <img
                      class="cultureType_2"
                      :src="item.iconTwo"
                      v-if="chooseValue == item.id"
                    />
                    <img class="cultureType_2" :src="item.icon" v-else />
                    <div class="cultureType_3">
                      <span class="cultureType_4">{{ item.title }}</span>
                      <span class="cultureType_5">{{ item.enTitle }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- pc端数据获取 -->
          <!-- <div style="height: 1px; width: 100%"></div> -->
          <div  v-if="pcshow" style="text-align: left; margin: 0px" >
            <div class="travel_con">
              <div class="">
                <!-- 图片显示 -->
                <el-row style="margin-right: 0px; margin-top: 35px">
                  <div v-if="dataList.length == 0">暂无数据</div>
                  <!--  PC端 -->
                  <div v-for="item in dataList" :key="item.key">
                    <el-col
                      :xs="24"
                      :sm="24"
                      :md="24"
                      :lg="24"
                      :xl="24"
                      style="
                        background-color: #fff;
                        border-bottom: 1px solid #f3efefe0;
                      "
                    >
                      <div class="showPictureforCulture" :style="{ float: item.position }" >
                        <img
                          :src="item.url"
                          alt="...."
                          :class="item.typeName ==='名人轶事'?'sceneryImgSizeforCultureFor18':'sceneryImgSizeforCultureFor28'"

                        />
                        <!-- <img
                          :src="item.url"
                          alt="...."
                          class="sceneryImgSizeforCulture"

                        /> -->
                        <div class="sceneryFontSizeforCulture">
                          {{ item.title }}
                        </div>
                        <span :class="['sceneryDescFontSizeforCulture',item.typeName ==='名人轶事'?'sceneryDescFontSizeforCulture1017':'sceneryDescFontSizeforCulture917']">{{
                          item.introduce
                        }}</span>
                        <button class="sceneryBtnforCulture" @click="seeInfo(item)">
                          查看更多
                        </button>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </div>
          </div>

          <div  v-if="!pcshow" style="text-align: left; margin: 0px" >
            <div class="travel_con">
              <div class="">
                <!-- 图片显示 -->
                <el-row style="margin-right: 0px; margin-top: 35px">
                  <div v-if="dataList.length == 0" style="margin-left:20px">暂无数据</div>
                  <!--  端 -->
                  <div v-for="item in dataList" :key="item.key">
                    <el-col
                      :xs="24"
                      :sm="24"
                      :md="24"
                      :lg="24"
                      :xl="24"
                      style="
                        background-color: #fff;
                        border-bottom: 1px solid #f3efefe0;
                      "
                    >
                      <div

                        class="showPictureforCulture"
                        :style="{ float: item.position }"
                      >
                        <img
                          :src="item.url"
                          alt="...."
                          class="sceneryImgSizeforCultureForP"
                        />
                        <div class="sceneryFontSizeforCultureForP">
                          {{ item.title }}
                        </div>
                        <span class="sceneryDescFontSizeforCultureForP">{{
                          item.introduce
                        }}</span>
                        <button
                          class="sceneryBtnforCulture"
                          @click="seeInfo(item)"
                        >
                          查看更多
                        </button>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getWHList, getCultureTypeList } from '@/api/public'
import Header from './header'
import Footer from './footer'
export default {
  components: { Header, Footer },
  data () {
    return {
      showbackground: 1,
      choseValue: 1,
      pcshow: false,
      styletable: {
        background:
          'linear-gradient(270deg, rgba(132, 2, 7, 0.29), rgba(132, 2, 7, 0))'
      },
      mapStyle: {
      },
      dataList: [],
      listCaiDan: [],
      title: '',
      chooseValue: 1
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },

  mounted () {
    this.getCultureTypeListFunction()
  },

  methods: {
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    // 选择菜单
    chooseTab (info) {
      console.log('0000')
      this.chooseValue = info.id
      this.title = info.title
      this.initWHList(this.title)
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    select (num) {
      console.log('3333', num)
    },
    initWHList (value) {
      getWHList(value).then(response => {
        var list = response.data
        this.dataList = list.sort(this.compare('sort'))
      })
    },
    getCultureTypeListFunction () {
      getCultureTypeList().then(response => {
        this.listCaiDan = response.data
        this.listCaiDan.length > 0
          ? ((this.chooseValue = this.listCaiDan[0].id),
          (this.title = this.listCaiDan[0].title))
          : ''
        this.initWHList(this.title)
      })
    },
    // 菜单选择
    tabSelect (e) {
      let value = e.target.dataset.index
      this.choseValue = value
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfo',
        query: {
          id: infoid
        }
      })
    }
  }
}
</script>
<style>
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.tra_tab {
  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFont {
  font-size: 42px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.sceneryImgSizeforCulture {
  padding: 20px;
  height: 200px;
  width: 280px;
  float: left;
  display: block;
}
.sceneryImgSizeforCultureFor28 {
  padding: 20px;
  height: 200px;
  width: 280px;
  float: left;
  display: block;
}
.sceneryImgSizeforCultureFor18 {
  padding: 20px;
  height: 200px;
  width: 180px;
  float: left;
  display: block;
}
.sceneryImgSizeforCultureForP {
  padding: 20px;
  height: 100%;
  width: 100%;
  float: left;
  display: block;
}

.sceneryFontSizeforCulture {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 917px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  margin-top: 15px;
  float: left;
}
.sceneryFontSizeforCultureForP {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 917px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  margin-top: -5px;
  float: left;
}
.showPictureforCulture {
  /* display: flex;
  flex-direction: column; */
  /* background-color: #ffffff; */
}
.sceneryDescFontSizeforCultureForP {
  float: left;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  width: 100%;
  height: 90px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryDescFontSizeforCulture {
  float: left;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  height: 90px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryDescFontSizeforCulture917{
   width: 917px;
}
.sceneryDescFontSizeforCulture1017{
   width: 1017px;
}
.sceneryBtnforCulture {
  float: left;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: black;
  width: 120px;
  height: 35px;
  padding: 0 20px;
  border: 1px solid #ccc;
  background-color: #fff;
  margin-left: 20px;
  margin-bottom: 10px;
}

.mobileSceneryDescFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  max-height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mobileSceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin-right: 10px;
  margin-bottom: 5px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.culturetab .table-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
}
.culturetab .table-button {
  min-width: 161px;
  height: 50px;
  border-radius: 4px;
  border-radius: 4px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #fff5e0;
  cursor: pointer;
}
.cultureType_1 {
  display: flex;
  flex-direction: row;
}
.cultureType_2 {
  width: 37px;
  height: 37px;
  margin: 7px;
}
.cultureType_3 {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.cultureType_4 {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #840207;
  line-height: 18px;
  padding-top:7px
}
.cultureType_5 {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #840207;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Culture.vue